import React from 'react';
import { Tooltip } from '@usepepper/sprout-kit-ui';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  label: string;
  tooltipText?: string;
}

export const PricingTableHeaderLabel: React.FC<Props> = ({
  label,
  tooltipText,
}) => {
  const theme = useTheme();

  if (!tooltipText) {
    return (
      <Typography
        color={theme.sk.color.text.tertiary}
        variant="paragraph-sm-600"
      >
        {label}
      </Typography>
    );
  }

  return (
    <Tooltip placement="top">
      <Tooltip.Trigger>
        <Typography
          color={theme.sk.color.text.tertiary}
          variant="paragraph-sm-600"
        >
          {label}
        </Typography>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Typography color={theme.sk.color.text.ondark} variant="paragraph-sm">
          {tooltipText}
        </Typography>
      </Tooltip.Content>
    </Tooltip>
  );
};
